import React, { CSSProperties, ReactNode } from 'react'
import { ButtonAIWrapper, Text } from './ButtonAI.css'

interface IButtonAIProps {
    children: ReactNode
    onClick?: () => void
    style?: CSSProperties
}

const ButtonAI = (props: IButtonAIProps) => {
    const { style } = props

    return (
        <ButtonAIWrapper onClick={() => props.onClick && props.onClick()} style={style}>
            <Text>{props.children}</Text>
        </ButtonAIWrapper>
    )
}

export default ButtonAI
